define('core/extensions/helpers/any',[],function () {
    'use strict';

    // emulate {= a || b}
    // TODO: is it better to return undefined or '' (empty string)?
    return function () {
        var len = arguments.length;
        for (var i = 0; i < len - 1; i++) {
            if (arguments[i])
                return arguments[i];
        }
    };
});

